import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.freeze.success.title',
        defaultMessage: 'Your card is now frozen',
    },
    subtitle: {
        id: 'modal.freeze.success.subtitle',
        defaultMessage: 'To unfreeze it later, contact support',
    },
    button: {
        id: 'modal.freeze.success.got_it',
        defaultMessage: 'Got it',
    },
})
